import { Component, Fragment } from "react";
import { Listbox } from '@headlessui/react';

class CourseFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {  }
  }

  render() {
    return (
      <div
        className="relative w-full"
      >
        <Listbox value={this.props.selected} onChange={(value) => this.props.onChange(value)} >
          <Listbox.Label className="hidden">{this.props.options[0].name}</Listbox.Label>
          <Listbox.Button className="w-full pl-2 pr-12 border-2 rounded-lg border-khaki-default bg-white bg-chevron bg-no-repeat bg-right text-left h-11 leading-10 overflow-hidden break-all" title={this.props.selected.name}>
            {this.props.selected.name}
          </Listbox.Button>
            <div className="z-20 absolute w-full px-1">
              <Listbox.Options className="w-full max-h-60 overflow-auto scrollbar-w-1 scrollbar-thumb-khaki-default bg-khaki-light border-2 border-khaki-default border-t-0">
                {this.props.options.map((option, index) => (
                  <Listbox.Option
                    key={index}
                    value={option}
                    as={Fragment}
                  >
                    {({ active, selected }) => (
                      <li className={`${active || selected ? 'bg-khaki-default text-white' : 'bg-khaki-light'} py-1 px-2`}>
                        {option.name}
                      </li>
                    )}
                  </Listbox.Option>
                ))}
              </Listbox.Options>
            </div>
        </Listbox>
      </div>
    );
  }

  setSelected(value) {
    this.setState({ selected: value });
  }

}


export default CourseFilter;